import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/companies/constants';
import { companiesQueryKeys } from '@/modules/companies/queries/queryKeys';
import { invalidateQuery } from '@/utils/queries';

export const useDeleteCompanyMutation = () => {
  return useMutation({
    mutationFn: (id: string) =>
      fetchClient.DELETE(endpoints.company, { params: { path: { id } } }),
    onSettled: () => {
      invalidateQuery(companiesQueryKeys.list())();
    },
  });
};
